import React from "react";
import { useSelector } from "react-redux";
import GroupUserTable from "./GroupUserTable";
import GroupDocument from "./GroupDocument";
import GroupLicenseTable from "./GroupLicenseTable";
import GroupCustomerDetail from "./GroupCustomerDetail";
import GroupDetailForm from "./GroupDetailForm";
const GroupDetailPage = () => {
  const { currentGroup } = useSelector((state) => state.group);
  const clientId = currentGroup?._id; // Using Group _id as the clientId for APIs


  return (
    <div>
      <GroupDetailForm/>
      <GroupDocument />
      <GroupLicenseTable />
      <GroupUserTable clientId={clientId} />
      <GroupCustomerDetail  />
    </div>
  );
};

export default GroupDetailPage;
